"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputTooltip = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var Tooltip_1 = require("../Tooltip");

var StyledTooltip = styled_components_1.default(Tooltip_1.Tooltip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 10px;\n  top: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  right: 10px;\n  top: 0;\n  bottom: 0;\n"])));

function InputTooltip(props) {
  return React.createElement(StyledTooltip, __assign({}, props));
}

exports.InputTooltip = InputTooltip;
var templateObject_1;